function quarticIn(t) {
  return Math.pow(t, 4.0)
}

module.exports = quarticIn